import React from "react"
import { Chip, FontIcon, IconButton } from "material-ui"
import strings from "../../../localization/strings"
import { IBadgeInfo } from "../../../models"
import ChooseBadgeDialogForChip from "./ChooseBadgeDialogForChip"
import AppStateStore from "../../../stores/AppStateStore"

interface IProps {
	readonly: boolean
	maxWidth?: number
	selectedBadges?: IBadgeInfo[]
	handleSave(Badges: IBadgeInfo[]): void
	handleDelete(Badges: IBadgeInfo[]): void
	singleBadge?: boolean
}
interface IState {
	selectedBadges: IBadgeInfo[]
	openChooseDialog: boolean
}

export default class ChooseBadgeChip extends React.Component<IProps, IState>  {
	constructor(props) {
		super(props)
		this.state = {
			selectedBadges: props.selectedBadges,
			openChooseDialog: false,
		}
	}


	render() {
		return !(this.props.readonly && this.props.selectedBadges.length === 0) && (
			<div style={{ width: 350 }}>
				<div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.298)" }}>
					{!this.props.singleBadge ? strings.Badges : "Badge"}
				</div>
				<div style={{ display: "flex", flexWrap: "wrap", }}>
					{this.state.selectedBadges && this.state.selectedBadges.length > 0 &&
						this.state.selectedBadges.map((badge, index) => (
							<Chip
								key={index}
								style={{ margin: 2, height: 35, width: "min-content", }}
								onRequestDelete={this.props.readonly ?
									null :
									() => {
										const selectedBadges = this.state.selectedBadges.filter((_badge, _index) => _index !== index)
										this.setState({ selectedBadges })
										this.props.handleDelete(selectedBadges)
									}
								}
							>
								<div
									className="TextOverflow"
									title={badge.Name}
									style={{ maxWidth: this.props.maxWidth }}
								>
									{badge.Name}
								</div>
							</Chip>
						))
					}
					{!this.props.readonly && !(this.props.singleBadge && this.state.selectedBadges && this.state.selectedBadges.length == 1) &&
						<IconButton
							style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}
							onTouchTap={() => this.setState({ openChooseDialog: true })}
						>
							<FontIcon className="fa fa-plus-circle" />
						</IconButton>
					}
					{this.state.openChooseDialog &&
						<ChooseBadgeDialogForChip
							handleClose={() => this.setState({ openChooseDialog: false })}
							handleSave={selectedBadges => {
								this.state.selectedBadges.find(i => selectedBadges.map(j => j.Id).includes(i.Id)) ?
									AppStateStore.setAlertDialogContent({
										content: strings.Duplicated_badge_exist
									}) :
									this.setState({
										openChooseDialog: false,
										selectedBadges: [...this.state.selectedBadges, ...selectedBadges]
									}, () =>
										this.props.handleSave(selectedBadges)
									)

							}}
						/>
					}
				</div>
			</div>
		)
	}
}